import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "",
  description:
    "In this principle we are going to demonstrate the effect a closed space has on sound by letting you listen to the same sound without echo or reverberation. This is achieved by recording in an anechoic room.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colSpan: {
        "0:0": 2,
      },
      rowsSize: [3, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/02/principle/slide-1.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "anechoic room",
                  theme: "primary",
                  icon: "cil-volume",
                  shape: "round",
                  size: "large",
                  url: `${config.ASSETS_URL}/05/02/principle/anechoic-room.wav`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "audioButton",
                options: {
                  text: "reverberant room",
                  theme: "secondary",
                  icon: "cil-volume",
                  shape: "round",
                  size: "large",
                  url: `${config.ASSETS_URL}/05/02/principle/reverberant-room.wav`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
